import { render } from "./CargoRecord.vue?vue&type=template&id=1e64b042&scoped=true"
import script from "./CargoRecord.vue?vue&type=script&lang=js"
export * from "./CargoRecord.vue?vue&type=script&lang=js"

import "./CargoRecord.vue?vue&type=style&index=0&id=1e64b042&scoped=true&lang=css"
import "./CargoRecord.vue?vue&type=style&index=1&id=1e64b042&lang=css"
import "./CargoRecord.vue?vue&type=style&index=2&id=1e64b042&scoped=true&lang=css"
import "@vueform/multiselect/themes/default.css?vue&type=style&index=3&id=1e64b042&scoped=true&lang=css"

import exportComponent from "/var/www/www.newtoncommoditiesscripts.com/vue-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e64b042"]])

export default __exports__